import { CoverPhoto } from './CoverPhoto';
export default CoverPhoto;
